<template>
  <LoadingIndicator />
</template>

<script>
import { get } from 'lodash-es';
import { mapActions } from 'pinia';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import { assetModuleDefault } from '@/lib/constants/moduleDefaults';
import * as types from '@/lib/constants/store';
import { newPageTemplate } from '@/lib/utils/store';
import {
  useEditorStore,
  useErrorStore,
} from '@/stores';

export default {
  name: 'CreateWithStudio',
  components: {
    LoadingIndicator,
  },
  computed: {
    assetId() {
      return get(this.$route, 'query.asset_id');
    },
    type() {
      return get(this.$route, 'query.type', 'board');
    },
    gridDisabled() {
      return this.type !== 'board';
    },
  },
  async created() {
    if (!this.assetId) {
      this[types.SET_ERROR]({
        active: true,
        error: {
          meta: {
            message: this.$t('Please provide an asset id.'),
          },
        },
      });
      return;
    }

    // Images use a different initial layout than other assets; we need asset data
    // to know whether we're dealing with an image or not. A 404 or other error will
    // still create a new draft with that (errored) asset, so the user can decide
    // how to proceed.
    const assetResponse = await this.$deApi(`/assets/${this.assetId}`);

    const newModule = assetModuleDefault(this.gridDisabled, assetResponse?.data?.asset);
    newModule.options.asset_id = this.assetId;

    // Note: A failed XHR will get caught in the Pinia action
    const newDraft = await this[types.CREATE_DRAFT]({
      originAssetId: this.assetId,
      pages: [
        {
          ...newPageTemplate(this.type),
          modules: [newModule],
        },
      ],
      type: this.type,
    });

    if (newDraft) {
      // New drafts always have a single reference
      const draftReference = newDraft.references[0];
      this.$router.replace(`/edit?id=${draftReference.reference_id}`);
    }
  },
  methods: {
    ...mapActions(useEditorStore, [
      types.CREATE_DRAFT,
    ]),
    ...mapActions(useErrorStore, [
      types.SET_ERROR,
    ]),
  },
};
</script>
